import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TopBarComponent } from './top-bar/top-bar.component';
import { TopBarItemComponent } from './top-bar-item/top-bar-item.component';
import { TranslateModule } from '@ngx-translate/core';
import { ContainerComponent } from './container/container.component';
import { TableHeaderComponent } from './table-header/table-header.component';
import { InputComponent } from './input/input.component';
import { EmptyTableMessageComponent } from './empty-table-message/empty-table-message.component';
import { MobileHeaderComponent } from './mobile-header/mobile-header.component';
import { ShowRowComponent } from './show-row/show-row.component';
import { CellContainerComponent } from './cell-container/cell-container.component';
import { WhiteBlockComponent } from './white-block/white-block.component';
import { HeaderBlockComponent } from './header-block/header-block.component';
import { SettingsHeaderComponent } from './settings-header/settings-header.component';
import { SettingsBodyComponent } from './settings-body/settings-body.component';
import { SettingsBlockComponent } from './settings-block/settings-block.component';
import { UserComponent } from './user/user.component';
import { Ng1AvatarDirective } from './ng1-avatar.directive';
import { SettingsFooterComponent } from './settings-footer/settings-footer.component';
import { BoxComponent } from './box/box.component';
import { SectionComponent } from './section/section.component';
import { SettingsRowComponent } from 'app/shared/layout/settings-row/settings-row.component';
import { FlagNumberItemComponent } from './flag-number-item/flag-number-item.component';
import { LittleLoaderComponent } from './little-loader/little-loader.component';
import { FlagLabelItemComponent } from './flag-label-item/flag-label-item.component';

const components = [
  TopBarComponent,
  TopBarItemComponent,
  ContainerComponent,
  TableHeaderComponent,
  InputComponent,
  EmptyTableMessageComponent,
  MobileHeaderComponent,
  ShowRowComponent,
  CellContainerComponent,
  WhiteBlockComponent,
  HeaderBlockComponent,
  SettingsHeaderComponent,
  SettingsBodyComponent,
  SettingsBlockComponent,
  SettingsFooterComponent,
  SettingsRowComponent,
  UserComponent,
  BoxComponent,
  SectionComponent,
  Ng1AvatarDirective,
  FlagNumberItemComponent,
  LittleLoaderComponent,
  FlagLabelItemComponent
];

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: components,
  exports: components
})
export class LayoutModule {}
